// extracted by mini-css-extract-plugin
export default {"btn":"SecondaryButton_btn__NY60L","btn__variant":"SecondaryButton_btn__variant__flISY"};